import './PostHead.scss';

const PostHead = ({ children }) => {
  return <div className="PostHead">{children}</div>;
};

export default PostHead;
